import { gql } from '@apollo/client';

/**
 * 降级配置类型定义
 */
export interface DegradeConfigType {
    level: number;
    blockedOperations: string[];
    p0Whitelist: string[];
    p1Whitelist: string[];
    p2Blacklist: string[];
}

export interface GetDegradeConfigResponse {
    getDegradeConfig: DegradeConfigType;
}

export interface SetDegradeLevelResponse {
    setDegradeLevel: boolean;
}

export interface UpdateDegradeOperationListResponse {
    updateDegradeOperationList: boolean;
}

export interface BlockOperationResponse {
    blockOperation: boolean;
}

export interface UnblockOperationResponse {
    unblockOperation: boolean;
}

export type DegradeListType = 'P0_WHITELIST' | 'P1_WHITELIST' | 'P2_BLACKLIST';

/**
 * 查询当前降级配置
 */
export const GET_DEGRADE_CONFIG = gql`
    query GetDegradeConfig {
        getDegradeConfig {
            level
            blockedOperations
            p0Whitelist
            p1Whitelist
            p2Blacklist
        }
    }
`;

/**
 * 设置降级级别
 */
export const SET_DEGRADE_LEVEL = gql`
    mutation SetDegradeLevel($level: Int!, $confirmDangerousOperation: Boolean) {
        setDegradeLevel(level: $level, confirmDangerousOperation: $confirmDangerousOperation)
    }
`;

/**
 * 更新降级 operation 列表
 */
export const UPDATE_DEGRADE_OPERATION_LIST = gql`
    mutation UpdateDegradeOperationList($type: DegradeListTypeInput!, $operations: [String!]!) {
        updateDegradeOperationList(type: $type, operations: $operations)
    }
`;

/**
 * 封禁单个 operation
 */
export const BLOCK_OPERATION = gql`
    mutation BlockOperation($operationName: String!) {
        blockOperation(operationName: $operationName)
    }
`;

/**
 * 解除封禁单个 operation
 */
export const UNBLOCK_OPERATION = gql`
    mutation UnblockOperation($operationName: String!) {
        unblockOperation(operationName: $operationName)
    }
`;
